import { Rechnung } from "./rechnung"
import { ErrorDto } from "./Validation"

export class ValidierteXRechnung {
    constructor(
        public rechnung: Rechnung,
        public format: string,
        public xmlData: string,
        public validierungErfolgreich: boolean,
        public bericht: string,
        public xmlDateiname: string,
        public validierungFehler?: ErrorDto[],
    ) {}

    static fromJSON(json: any): ValidierteXRechnung {
        return new ValidierteXRechnung(
            json.rechnung,
            json.format,
            json.xmlData,
            json.validierungErfolgreich,
            json.bericht,
            json.xmlDateiname,
            json.validierungFehler,
        )
    }
}
